<template>
  <div class="pa-4">
    <v-list>
      <v-list-group v-for="(section, index) in navItems" :key="index" no-action>
        <template v-slot:appendIcon>
          <v-icon color="accent"> arrow_right </v-icon>
        </template>
        <template v-slot:activator>
          <v-list-item-content @click="goToDamage(section)">
            <v-list-item-title v-text="section.header"></v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item
          v-for="childSection in section.sections"
          :key="childSection.title"
          @click.prevent="goTo(childSection.to, childSection.params)"
          v-show="childSection.visible"
        >
          <v-list-item-content>
            <v-list-item-title v-text="childSection.title"></v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon>
            <v-icon color="accent">arrow_right</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list-group>
    </v-list>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      navItems: [
        {
          header: "Tablero Dinámico",
          sections: [
            {
              title: "Todas las Sucursales",
              to: "dynamic-board-main",
              visible: true
            },
            {
              title: "Sucursal Toluca",
              to: "dynamic-board-branch",
              visible: true,
              params: "18"
            },
            {
              title: "Sucursal Aguascalientes",
              to: "dynamic-board-branch",
              visible: true,
              params: "19"
            },
            {
              title: "Sucursal Coatzacoalcos",
              to: "dynamic-board-branch",
              visible: true,
              params: "20"
            },
            {
              title: "Sucursal Cuatitlán",
              to: "dynamic-board-branch",
              visible: true,
              params: "21"
            },
            {
              title: "Sucursal Cuernavaca",
              to: "dynamic-board-branch",
              visible: true,
              params: "22"
            },
            {
              title: "Sucursal Guadalajara",
              to: "dynamic-board-branch",
              visible: true,
              params: "23"
            },
            {
              title: "Sucursal Tizayuca",
              to: "dynamic-board-branch",
              visible: true,
              params: "24"
            },
            {
              title: "Sucursal Mérida",
              to: "dynamic-board-branch",
              visible: true,
              params: "25"
            },
            {
              title: "Sucursal Monterrey",
              to: "dynamic-board-branch",
              visible: true,
              params: "26"
            },
            {
              title: "Sucursal Puebla",
              to: "dynamic-board-branch",
              visible: true,
              params: "27"
            },
            {
              title: "Sucursal Salitre",
              to: "dynamic-board-branch",
              visible: true,
              params: "28"
            },
            {
              title: "Sucursal San Luis Potosí",
              to: "dynamic-board-branch",
              visible: true,
              params: "29"
            },
            {
              title: "Sucursal Silao",
              to: "dynamic-board-branch",
              visible: true,
              params: "31"
            },
            {
              title: "Sucursal Veracruz",
              to: "dynamic-board-branch",
              visible: true,
              params: "33"
            },
            {
              title: "Sucursal San José Chiapa",
              to: "dynamic-board-branch",
              visible: true,
              params: "36"
            },
            {
              title: "Sucursal Corporativo",
              to: "dynamic-board-branch",
              visible: true,
              params: "1"
            }
          ]
        },
        { header: "Inspección de Daños", to: "dashboard" },
        {
          header: "Usuarios y Permisos",
          sections: [
            {
              title: "Registrar un Usuario",
              to: "usersAndPermissions",
              visible: true
            },
            { title: "Consultar Usuarios", to: "usersEdit", visible: true }
          ]
        },
        {
          header: "Indicadores",
          sections: [
            {
              title: "Editar Indicadores",
              to: "AddKpi",
              visible: true
            },
            { title: "Ver Indicadores", to: "ShowKpi", visible: true }
          ]
        }
      ]
    };
  },
  computed: {
    ...mapState("pwa", ["deferredPrompt"]),
    ...mapState("user", ["userAccess"])
  },
  beforeMount() {
    const sucursales = [
      "dynamic-board-sucursal-global",
      "dynamic-board-sucursal-toluca",
      "dynamic-board-sucursal-aguascalientes",
      "dynamic-board-sucursal-coatzacoalcos",
      "dynamic-board-sucursal-cuatitlan",
      "dynamic-board-sucursal-cuernavaca",
      "dynamic-board-sucursal-guadalajara",
      "dynamic-board-sucursal-tizayuca",
      "dynamic-board-sucursal-merida",
      "dynamic-board-sucursal-monterrey",
      "dynamic-board-sucursal-puebla",
      "dynamic-board-sucursal-salitre",
      "dynamic-board-sucursal-potosi",
      "dynamic-board-sucursal-silao",
      "dynamic-board-sucursal-veracruz",
      "dynamic-board-sucursal-chiapa",
      "dynamic-board-sucursal-corporativo"
    ];
    sucursales.forEach((sucursal, index) => {
      if (!this.userAccess[sucursal])
        this.navItems[0].sections[index].visible = false;
    });
  },
  methods: {
    ...mapActions("pwa", ["promptInstall"]),
    goTo(nameRoute, params) {
      if (params) {
        this.$router.push({
          name: nameRoute,
          params: { branchOffice: params }
        });
      } else {
        this.$router.push({ name: nameRoute });
      }
    },
    goToDamage(section) {
      this.$router.push({ name: section.to });
    }
  }
};
</script>
